export default "__VITE_ASSET__347c914e__"